var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
import createMuiSpacing from "@material-ui/core/styles/createSpacing";
export var spacing = {
    none: 0,
    xsmall: 0.5,
    small: 1,
    medium: 2,
    large: 3,
    xlarge: 4,
    xxlarge: 5,
};
export var getValueForSpacing = function (keyOrValue) {
    if (typeof keyOrValue === "number") {
        return keyOrValue;
    }
    return spacing[keyOrValue];
};
export var createSpacing = function (baseValue) {
    if (baseValue === void 0) { baseValue = 8; }
    var muiSpacing = createMuiSpacing(baseValue);
    var spacingFn = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (args.length === 0) {
            return muiSpacing();
        }
        var transformedArgs = args.map(function (v) { return (typeof v === "number" ? v : getValueForSpacing(v)); });
        return muiSpacing.apply(void 0, __spread(transformedArgs));
    };
    spacingFn.mui = true;
    return spacingFn;
};
